import moment from 'moment'
import { FC, useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { download_icon } from 'src/assets'
import { SAGA_GUARDS } from 'src/navigation'
import { shoot } from 'src/redux/actions'
import {
  select_company,
  select_formik_item,
  select_loading,
  select_otherdoc,
  select_otherdocs,
  select_quote,
} from 'src/redux/store'
import { modal_t, otherdoc_list_t } from 'src/types'
import { download_blob, get_language, to_blob } from 'src/utils'
import { Button, Loader, Modal } from 'src/widgets'

export const Documents: FC<modal_t> = ({ visible, on_close }: modal_t) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const col = 'col-12 px-sm-5 px-4'
  const col_l = `col-xl-4 col-lg-5 ${col}`
  const col_r = `col-xl-8 col-lg-7 ${col}`

  /**
   * Use Selector
   */
  const loading = useSelector(
    select_loading([SAGA_GUARDS.RESOLVE_OTHERDOCS, SAGA_GUARDS.RESOLVE_OTHERDOC])
  )
  const quote = useSelector(select_quote)
  const otherdocs = useSelector(select_otherdocs)
  const otherdoc = useSelector(select_otherdoc)
  const company = useSelector(select_company)?.key
  const product = useSelector(select_formik_item('ts1a__vehicle_type'))?.capture

  /**
   * Use State
   */
  const [currdoc, set_currdoc] = useState<otherdoc_list_t>()

  /**
   * Use Effect
   */
  useEffect(() => {
    if (otherdoc) {
      download_blob(to_blob(otherdoc?.content || ''), currdoc?.desStampa)
      dispatch(shoot.reduce_otherdoc())
    }
  }, [otherdoc])

  /**
   * Render functions
   */
  const render_doc = (doc: otherdoc_list_t, idx: number) => (
    <div key={idx} className="pt-5 pb-3 border-bottom">
      <p className="font-24">{doc?.desStampa}</p>

      <Button
        flavor="primary_flip_next"
        text={t('documents.download_document')}
        classes="p-0"
        iconr={download_icon}
        on_press={() => {
          set_currdoc(doc)
          dispatch(
            shoot.saga_resolve_otherdoc({
              numPoli: null,
              sotTipo: doc?.tipoStampa,
              codComp: quote?.company_code || company,
              codRamo: quote?.ramo_code
                ? `${quote?.ramo_code}_${doc?.prgStampa}`
                : `50_${doc?.prgStampa}`,
              codProd: quote?.parent_product_code || product?.split('-')[0],
              sysdate: doc?.sysDate,
              dataDecorrenza: moment(new Date()).format('YYYY-MM-DD'),
            })
          )
        }}
      />
    </div>
  )

  const render_docs = () => (
    <>
      <Col className={col_l}>
        <p className="font-48">{t('documents.rca_documents')}</p>
        <p className="m-0 p-0 font-20 c-7f7f7f">
          {'Prima della sottoscrizione assicurati di aver letto il set informativo'}
        </p>
      </Col>
      <Col className={col_r}>
        {otherdocs
          ?.filter((render_doc) => {
            const it_ = render_doc?.tipoStampa?.includes('_I')
            const de_ = render_doc?.tipoStampa?.includes('_D')
            return (
              (it_ && get_language() === 'IT') || (de_ && get_language() === 'DE') || (!it_ && !de_)
            )
          })
          ?.map(render_doc)}
      </Col>
    </>
  )

  return (
    <Modal visible={visible} on_close={on_close}>
      <>
        <Loader hidden={!loading} />
        <Row className="py-5">{render_docs()}</Row>
      </>
    </Modal>
  )
}
